// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import App from './App'
import router from './router'
import './assets/reset.mobile.min.css'
import './assets/normalize.css'
import AwesomePicker from 'vue-awesome-picker'
import Confirm from './components/confirm/index'
import { isWeixin } from './utils/common'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview, {
  // options
  fullscreenEl: false,
  arrowEl: false,
  counterEl: false,
  tapToClose: true
})
Vue.use(Confirm)
Vue.use(AwesomePicker)

Vue.config.productionTip = false
Vue.prototype.$isWx = isWeixin()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js